import { render, staticRenderFns } from "./WritingBlankType2Form.vue?vue&type=template&id=6ceb56ae&"
import script from "./WritingBlankType2Form.vue?vue&type=script&lang=js&"
export * from "./WritingBlankType2Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports